const oneMinute = 1000 * 60;
const tenMinutes = oneMinute * 10;
const oneHour = oneMinute * 60;
const oneDay = oneHour * 24;
const oneWeek = oneDay * 7;
const oneMonth = oneDay * 30; // approximately
const oneYear = oneDay * 365; // approximately

const getNow = () => Math.floor(new Date().getTime() / 1000);

const now = getNow();
const tenMinutesLater = Math.floor((new Date().getTime() + tenMinutes) / 1000);
const tenMinutesEarlier = Math.floor((new Date().getTime() - tenMinutes) / 1000);
const twentyMinutesEarlier = Math.floor((new Date().getTime() - 2 * tenMinutes) / 1000);
const thirtyMinutesEarlier = Math.floor((new Date().getTime() - 3 * tenMinutes) / 1000);
const oneWeekEarlier = Math.floor((new Date().getTime() - oneWeek) / 1000);
const oneMonthEarlier = Math.floor((new Date().getTime() - oneMonth) / 1000);
const eightMonthsEarlier = Math.floor((new Date().getTime() - 8 * oneMonth) / 1000);
const oneYearEarlier = Math.floor((new Date().getTime() - oneYear) / 1000);
const threeYearsEarlier = Math.floor((new Date().getTime() - 3 * oneYear) / 1000);

export const timestampMockHelpers = {
  getNowLive: getNow,
  now,
  tenMinutesLater,
  tenMinutesEarlier,
  twentyMinutesEarlier,
  thirtyMinutesEarlier,
  oneWeekEarlier,
  oneMonthEarlier,
  eightMonthsEarlier,
  oneYearEarlier,
  threeYearsEarlier,
};
